import React, {FunctionComponent} from 'react';

import {SimpleSelect, IItem} from '../../../../select';
import {SHARE_OPTIONS} from './constants';

interface SelectActionProps {
  selected?: string;
  disabled?: boolean;
  onChange: (value: any) => void;
}

const SelectAction: FunctionComponent<SelectActionProps> = ({
  selected,
  disabled = false,
  onChange,
}: SelectActionProps) => {

  return (
    <SimpleSelect
      selected={selected}
      disabled={disabled}
      onChange={onChange}
      options={SHARE_OPTIONS as IItem[]}
      popoverProps={{usePortal: true}}
    />
  );
};

export default SelectAction;
